import React from "react";
import {
  FaCircleCheck,
  FaEnvelope,
  FaFireFlameCurved,
  FaGlobe,
  FaLayerGroup,
  FaStar,
} from "react-icons/fa6";

export default function StatsBar({
  stats = {},
  searching = false,
  goToPipeline,
}) {
  const cards = [
    {
      key: "",
      title: "Total Leads",
      subtitle: "All opportunities",
      value: stats.total ?? 0,
      icon: FaLayerGroup,
      tone: "primary",
    },
    {
      key: "hot",
      title: "Hot Leads",
      subtitle: "High-intent prospects",
      value: stats.hot ?? 0,
      icon: FaFireFlameCurved,
      tone: "danger",
    },
    {
      key: "good",
      title: "Qualified",
      subtitle: "Score between 40–79",
      value: stats.good ?? 0,
      icon: FaStar,
      tone: "warning",
    },
    {
      key: "nosite",
      title: "No Website",
      subtitle: "Digital opportunity",
      value: stats.noSite ?? 0,
      icon: FaGlobe,
      tone: "purple",
    },
    {
      key: "contacted",
      title: "Contacted",
      subtitle: "Active conversations",
      value: stats.contacted ?? 0,
      icon: FaEnvelope,
      tone: "blue",
    },
    {
      key: "won",
      title: "Won",
      subtitle: "Closed opportunities",
      value: stats.won ?? 0,
      icon: FaCircleCheck,
      tone: "success",
    },
  ];

  const openPipeline = (filter) => {
    if (searching || typeof goToPipeline !== "function") return;
    goToPipeline(filter);
  };

  return (
    <section
      className={`wp-tile-section ${searching ? "is-disabled" : ""}`}
      aria-label="Lead pipeline summary"
    >
      <div className="wp-tile-grid">
        {cards.map((card) => {
          const Icon = card.icon;

          return (
            <button
              key={card.key || "total"}
              type="button"
              className={`wp-tile wp-tile-${card.tone}`}
              onClick={() => openPipeline(card.key)}
              disabled={searching}
              aria-label={`${card.title}: ${card.value}`}
            >
              <span className="wp-tile-icon" aria-hidden="true">
                <Icon />
              </span>

              <span className="wp-tile-value">
                {Number(card.value || 0).toLocaleString()}
              </span>

              <span className="wp-tile-copy">
                <span className="wp-tile-title">{card.title}</span>
                <span className="wp-tile-subtitle">{card.subtitle}</span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
